import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import SupervisorReceiptCompensationForm from "./supervisor-receipt-compensation-form";
import SupervisorReceiptCompensationData from "./supervisor-receipt-compensation-data";

const SupervisorReceiptCompensation = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_RECEIPT_COMPENSATION",
      "SUPERVISOR_RECEIPT_COMPENSATION"
    );
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SUPERVISOR_RECEIPT_COMPENSATION")}
        subTitle={i18n.get("SUPERVISOR_RECEIPT_COMPENSATION")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <SupervisorReceiptCompensationForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <SupervisorReceiptCompensationData />
    </ET3PageDiv>
  );
});
export default SupervisorReceiptCompensation;
